import $ from 'jquery';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '../scss/style.scss';

/*------------------------------------------
	common
------------------------------------------*/
// SP menu
(function($) {

  $(function() {
    $('.js-nav-btn').on('click',function() {
      $('.js-nav').fadeToggle();
      $(this).toggleClass('is-close');
    });
    $('.js-nav a[href^="#"]').on('click',function() {
      $('.js-nav').fadeOut();
      $('.js-nav-btn').removeClass('is-close');
    });

    // sub menu
    $('.js-nav-parent').on('click', function() {
      $('+ .js-nav-child', this).slideToggle();
      $(this).toggleClass('is-open');
    });
  });

  // SP CV（追従バーからの選択パネル）
  $(function() {
    $('.js-cv02-open').on('click', function (e) {
      e.preventDefault();
      $('.js-cv02-content').fadeIn();
    });
    $('.js-cv02-close').on('click', function () {
      $('.js-cv02-content').fadeOut();
    });
  });

  // SP 追従CV（.c-cv02）：スクロールがページ最下部に達したときだけ非表示
  document.addEventListener( 'DOMContentLoaded', function() {
    const cv02 = document.querySelector( '.c-cv02' );
    if ( !cv02 ) {
      return;
    }
    const mqSp = window.matchMedia( '(max-width: 767px)' );
    let ticking = false;

    function updateCv02FooterHidden() {
      if ( !mqSp.matches ) {
        cv02.classList.remove( 'is-hidden-at-footer' );
        return;
      }
      const innerH = window.innerHeight;
      const docH = document.documentElement.scrollHeight;
      const scrollY = window.scrollY || window.pageYOffset;
      const canScroll = docH > innerH + 2;
      const atBottom = scrollY + innerH >= docH - 2;
      cv02.classList.toggle( 'is-hidden-at-footer', canScroll && atBottom );
    }

    function onScroll() {
      if ( ticking ) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame( function() {
        updateCv02FooterHidden();
        ticking = false;
      } );
    }

    window.addEventListener( 'scroll', onScroll, { passive: true } );
    window.addEventListener( 'resize', updateCv02FooterHidden );
    mqSp.addEventListener( 'change', updateCv02FooterHidden );
    updateCv02FooterHidden();
  } );

  // PC reserve（ヘッダー CV からのモーダル）
  $(function() {
    $('.js-reserve02-open').on('click', function (e) {
      e.preventDefault();
      $('.js-reserve02').fadeIn();
    });
    $('.js-reserve02-close, .js-reserve02-overlay').on('click', function () {
      $('.js-reserve02').fadeOut();
    });
  });

  // SP reserve
  $(function() {
    $('.js-reserve01-open').on('click',function() {
      $('.js-reserve01').fadeIn();
    });
    $('.js-reserve01-close, .js-reserve01-overlay').on('click',function() {
      $('.js-reserve01').fadeOut();
    });
  });


  /*------------------------------------------
    home
  ------------------------------------------*/
  document.addEventListener( 'DOMContentLoaded', function() {

    // js-home-mv-slider
    if(document.getElementsByClassName('js-home-mv-slider').length) {
      var jsHomeMvSlider_option	=	{
            type					:	'fade',
            rewind				:	true,
            speed					:	3000,
            arrows				:	false,
            pagination		: false,
            autoplay			:	true,
            pauseOnHover	:	false,
            pauseOnFocus	:	false,
          },
          jsHomeMvSlider = new Splide( '.js-home-mv-slider', jsHomeMvSlider_option );
      jsHomeMvSlider.mount();
    }

    if(document.getElementsByClassName('js-home-department-slider').length) {
      var jsHomeDepartmentSlider_option	=	{
            type					:	'fade',
            rewind				:	true,
            speed					:	3000,
            arrows				:	false,
            pagination		: false,
            autoplay			:	true,
            pauseOnHover	:	false,
            pauseOnFocus	:	false,
          },
          jsHomeDepartmentSlider = new Splide( '.js-home-department-slider', jsHomeDepartmentSlider_option );

      // ナビゲーション、カウンター、ページャー要素の取得
      const navItems = document.querySelectorAll('.homeDepartment-nav__item');
      const totalCounter = document.querySelector('.homeDepartment-control-counter__total');
      const currentCounter = document.querySelector('.homeDepartment-control-counter__current');
      const prevButton = document.querySelector('.homeDepartment-control-pager__item.is-prev');
      const nextButton = document.querySelector('.homeDepartment-control-pager__item.is-next');

      // スライダーイベントのリスニング (スライド切り替え時)
      jsHomeDepartmentSlider.on('mounted move', () => {
          if (jsHomeDepartmentSlider.index === 0 && totalCounter) {
              totalCounter.textContent = jsHomeDepartmentSlider.length;
          }

          const currentIndex = jsHomeDepartmentSlider.index;

          // ナビゲーションのis-active切り替え
          navItems.forEach((item, index) => {
              if (index === currentIndex) {
                  item.classList.add('is-active');
              } else {
                  item.classList.remove('is-active');
              }
          });

          // カウンターの更新
          if (currentCounter) {
              currentCounter.textContent = currentIndex + 1;
          }
      });

      // homeDepartment-nav のホバーイベント
      navItems.forEach((item, index) => {
          // ホバーイベントを設定
          item.addEventListener('mouseenter', () => {
              // 目的のスライドに移動
              jsHomeDepartmentSlider.go(index);
          });
          // タッチデバイスでの予期せぬ動作を避けるため、クリックでも移動するように設定
          item.addEventListener('click', () => {
              jsHomeDepartmentSlider.go(index);
          });
      });

      if (prevButton) {
          prevButton.addEventListener('click', () => {
              jsHomeDepartmentSlider.go('<'); // 前のスライドへ
          });
      }
      if (nextButton) {
          nextButton.addEventListener('click', () => {
              jsHomeDepartmentSlider.go('>'); // 次のスライドへ
          });
      }
      jsHomeDepartmentSlider.mount();
    }

    // js-home-clinic-slider
    if(document.getElementsByClassName('js-home-clinic-slider').length) {
      var jsHomeClinicSlider_option	=	{
            type					:	'loop',
            gap						:	'20px',
            fixedWidth		:	'380px',
            arrows				:	false,
            pagination		: false,
            autoScroll: {
              speed					:	.7,
              pauseOnHover	:	false,
            },
            breakpoints		:	{
              767	: {
                gap						:	'16px',
                fixedWidth		:	'304px',
                autoScroll: {
                  speed					:	.5,
                },
              },
            },
          },
          jsHomeClinicSlider = new Splide( '.js-home-clinic-slider', jsHomeClinicSlider_option );
          jsHomeClinicSlider.mount({ AutoScroll });
    }

  });

})(jQuery);
